import React from 'react';
import classNames from 'classnames';

import ExternalLink from 'src/components/common/external-link';
import { ReactComponent as AfsLogoIcon } from 'src/assets/icons/logo-afs.svg';

import type { AfsLogoProps } from './afs-logo.props';

import './afs-logo.scss';

const AfsLogo = ({ className }: AfsLogoProps) => {
  return (
    <ExternalLink
      className={classNames('afs-logo', className)}
      href="https://allfuneral.com/"
      title="All Funeral Services"
    >
      <AfsLogoIcon className="afs-logo__img" />
    </ExternalLink>
  );
};

export default AfsLogo;
